var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#EEEFF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.6875 26.75H17.3125C15.4873 26.75 14 28.1812 14 29.9375V58.625C14 60.3845 15.4873 61.8125 17.3125 61.8125H63.6875C65.516 61.8125 67 60.3845 67 58.625V29.9375C67 28.1812 65.516 26.75 63.6875 26.75Z",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33.125H14V42.6875H67V33.125Z",
    fill: "#000624"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9062 52.25H22.2812C21.367 52.25 20.625 51.536 20.625 50.6562C20.625 49.7765 21.367 49.0625 22.2812 49.0625H28.9062C29.8205 49.0625 30.5625 49.7765 30.5625 50.6562C30.5625 51.536 29.8205 52.25 28.9062 52.25Z",
    fill: "#FFBC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67 42.5154V29.9375C67 28.1812 65.516 26.75 63.6875 26.75H37.1875V29.9375C37.1875 39.9208 41.136 45.9993 51.2855 51.6221C52.0341 52.0332 52.8888 52.25 53.75 52.25C54.6112 52.25 55.4659 52.0332 56.2244 51.6157C61.2462 48.8394 64.7442 45.9419 67 42.5154Z",
    fill: "#FAFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9963 22.0978L54.4026 17.3166C53.9819 17.1445 53.5148 17.1445 53.0941 17.3166L41.5004 22.0978C40.8942 22.3465 40.5 22.9234 40.5 23.5609V29.9359C40.5 38.7047 43.8688 43.8302 52.9252 48.8505C53.1803 48.9908 53.4651 49.0609 53.75 49.0609C54.0349 49.0609 54.3197 48.9908 54.5748 48.8505C63.6312 43.843 67 38.7175 67 29.9359V23.5609C67 22.9234 66.6058 22.3465 65.9963 22.0978Z",
    fill: "#004080"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0935 37.9051C52.0703 37.9051 52.0438 37.9051 52.0239 37.9051C51.4972 37.8827 51.0103 37.6214 50.7155 37.1974L47.403 32.4162C46.8961 31.6831 47.1015 30.6949 47.8634 30.2072C48.6186 29.7227 49.6488 29.914 50.159 30.6503L52.216 33.6179L57.4233 27.3512C57.9963 26.6659 59.0398 26.5576 59.752 27.1026C60.4675 27.6541 60.5801 28.6549 60.0103 29.3434L53.3853 37.3122C53.0706 37.6851 52.5936 37.9051 52.0935 37.9051Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/paymentSuccess.36190407dc48589bcfb467177c7e32d0.svg";
export { ForwardRef as ReactComponent };